<template>
    <div class="ion-page">
        <ion-content class="ion-padding">
            <div class="page">
                <ion-grid class="page-center page-content">
                    <ion-row class="rectangle">
                        <ion-col size="12" class="col-padding">
                        <ion-label
                            class="light-text"
                        >Admin user not able use the mobile application. Please use the web.</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue"

export default defineComponent ({
    name: 'gotoWebLogin',
    data() {
        return {

        }
    },
    methods: {
        gotoLogin() {
            this.$router.push("/login");
        }
    }
})
</script>